// extracted by mini-css-extract-plugin
export var body = "_l4-0";
export var sectionHeader = "_l4-4";
export var shortcutColumns = "_l4-2";
export var shortcutList = "_l4-1";
export var shortcutSection = "_l4-3";